import { post } from './http';

export const GetDealer = async (dealerId) =>
  await post('api/dealer/setMyDealer', { dealerId });
